module.exports = __webpack_public_path__ + "img/47.495b95ec.png";